import React from 'react';
import Select from 'react-select';

const CategorySelect = ({ categories, selectedCategories, onChange }) => {
    const options = categories.map((cat) => ({
        value: cat._id,
        label: cat.name,
    }));

    const selectedIds = Array.isArray(selectedCategories)
        ? selectedCategories.map((cat) => (typeof cat === 'object' ? cat._id : cat))
        : selectedCategories
          ? [typeof selectedCategories === 'object' ? selectedCategories._id : selectedCategories]
          : [];

    const value = options.filter((option) => selectedIds.includes(option.value));

    const handleChange = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value);
        onChange(selectedIds);
    };

    return (
        <div className="mb-3 category-select-wrapper">
            {/*<label className="form-label">Categorías</label>*/}
            <Select
                isMulti
                options={options}
                value={value}
                onChange={handleChange}
                placeholder="Seleccione Categorías"
                className="basic-multi-select"
                classNamePrefix="select"
                menuPortalTarget={document.body}
                styles={{
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                }}
            />
        </div>
    );
};

export default CategorySelect;
